module.exports = __webpack_public_path__ + "media/tnr/bghead-b2d15beb.png";